import { GetEmailTemplateResponse } from "../api/emailApi";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "emailTemplateTab",
  initialState: {} as SliceState<GetEmailTemplateResponse>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const emailTemplateTabReducer = formSlice.reducer;
export default emailTemplateTabReducer;
